<template>
  <div class="pos_container_panel" style="padding-left: 2rem; width: 90%">
    <Loading :loading="submitLoading" />
    <!--add area-->
    <el-form
      :inline="true"
      :model="searchForm"
      class="demo-form-inline"
      style="margin-left: 6rem; padding-top: 2rem"
    >
      <el-row style="">
        <el-col :span="16">
          <div class="grid-content bg-purple">
            <el-form-item label="酒店集团名称">
              <el-input v-model="searchForm.name" autocomplete="off"></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-light"></div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="float: right">
          <div class="grid-content bg-purple-light" style="float: right">
            <el-button type="warning" class="harpIDbtn" @click="customSearch(1)">
              搜索</el-button
            >
            <el-button
              type="warning"
              class="harpIDbtn"
              style="margin-left: 3rem"
              @click="addGroup()"
            >
              新增
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <!--table-->
    <el-table
      :data="tableData"
      border
      style="width: 90%; margin-top: 50px; margin-left: 100px"
      :default-sort = "{prop: 'score', order: 'descending'}" @sort-change="sortChange"
    >
      <el-table-column prop="id" label="code" align="center"></el-table-column>
      <el-table-column
        prop="cName"
        label="中文"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="eName"
        label="英文"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="status"
        label="是否启用"
        align="center"
        :formatter="Format"
      ></el-table-column>
      <el-table-column
        prop="createdDate"
        label="创建时间"
        align="center"
        :formatter="Format"
      ></el-table-column>
      <el-table-column prop="score" label="分值(0-10)" align="center" sortable = 'custom'></el-table-column>
      <el-table-column label="操作" width="150" align="center">
        <template #default="scope">
          <el-button @click="handleSetting(scope.row)" type="text" size="small">配置映射</el-button>
          <el-button @click="handleChange(scope.row)" type="text" size="small">修改</el-button>
          <el-button type="text" size="small" @click.prevent="deleteRow(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-bottom: 1rem">
      <el-pagination
        class="paginationsty"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        v-model:current-page="currentPage1"
        :page-size="10"
        layout="total, prev, pager, next"
        :total="searchForm.total"
      />
    </div>
    <!--新增 dialog-->
    <el-dialog
      title="新增"
      v-model="dialogFormVisible"
      @close="closeaddDialog('form')"
      
    >
      <el-form :model="form" ref="form">
        <el-form-item
          label="酒店集团名称-中文:"
          :label-width="formLabelWidth"
          prop="CName"
          :rules="[
            {
              required: true,
              message: '请输入酒店集团名称-中文',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="form.CName"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="酒店集团名称-英文:"
          :label-width="formLabelWidth"
          prop="EName"
          :rules="[
            {
              required: true,
              message: '请输入酒店集团名称-英文',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="form.EName"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="是否启用:"
          :label-width="formLabelWidth"
          prop="status"
          :rules="[
            {
              required: true,
              message: '请选择是否启用',
              trigger: 'blur',
            },
          ]"
        >
          <el-radio-group v-model="form.status" style="margin-left: 85px">
            <el-radio label="true">是</el-radio>
            <el-radio label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分值(0-10):" :label-width="formLabelWidth" prop="score"
        :rules="[
            {
              pattern: /^[0-9]$|^10$/,
              message: '请输入0到10的分数',
              trigger: ['blur','change'],
            },
          ]">
          <el-input v-model="form.score" autocomplete="off" style="width: 58%; margin-left: 85px"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="dataSave()">保存</el-button>
          <el-button @click="cancel()">取 消</el-button>
        </div>
      </template>
    </el-dialog>
    <!--修改 dialog-->
    <el-dialog title="修改" v-model="changeCountryFlag" >
      <el-form :model="changeForm" ref="editForm">
        <el-form-item
          label="酒店集团名称-中文:"
          :label-width="formLabelWidth"
          prop="CName"
          :rules="[
            {
              required: true,
              message: '请输入酒店集团名称-中文',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="changeForm.CName"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="酒店集团名称-英文:"
          :label-width="formLabelWidth"
          prop="EName"
          :rules="[
            {
              required: true,
              message: '请输入酒店集团名称-英文',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="changeForm.EName"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="是否启用:"
          :label-width="formLabelWidth"
          prop="status"
          :rules="[
            {
              required: true,
              message: '请选择是否启用',
              trigger: 'blur',
            },
          ]"
        >
          <el-radio-group v-model="changeForm.status" style="margin-left: 85px">
            <el-radio label="true">是</el-radio>
            <el-radio label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分值(0-10):" :label-width="formLabelWidth" prop="score"
        :rules="[
            {
              pattern: /^[0-9]$|^10$/,
              message: '请输入0到10的分数',
              trigger: ['blur','change'],
            },
          ]">
          <el-input v-model="changeForm.score" autocomplete="off" style="width: 58%; margin-left: 85px"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="changeSave()">保存</el-button>
          <el-button @click="cancel()">取 消</el-button>
        </div>
      </template>
    </el-dialog>
    <!--删除 dialog-->
    <el-dialog
      title=""
      v-model="deletedialogVisible"
      width="30%"
      
    >
      <span>请确认是否删除</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="confirmDelete">确 定</el-button>
          <el-button @click="cancelDelete">取 消</el-button>
        </span>
      </template>
    </el-dialog>
    <!--配置酒店集团 dialog-->
    <el-dialog
      title="配置映射酒店集团"
      v-model="settingMappingFlag"
      
      :close-on-click-modal="false"
    >
      <el-tag
        :key="tag.id"
        v-for="tag in dynamicTags"
        closable
        :disable-transitions="false"
        @close="handleClose(tag)"
        style="margin: 0px 10px 5px 0px"
      >
        {{ tag.cName }}
      </el-tag>
      <el-input
        class="input-new-tag"
        v-if="inputVisible"
        v-model="inputValue"
        ref="saveTagInput"
        size="small"
        style="width: 120px"
        @keyup.enter="handleInputConfirm"
        @blur="handleInputConfirm"
      />
      <el-button v-else class="button-new-tag" size="small" @click="showInput"
        >+ New Tag</el-button
      >
    </el-dialog>
    <ConfirmBoxs
      :centerDialogVisible="confirmFlag"
      :confirmMsg="confirmMsg"
      :icon="confirmIcon"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
  </div>
</template>

<script>
import {
  hbeGroupList,
  hbeGroupSave,
  hbeGroupDelete,
  hbeGetMapping,
  hbeDeleteMapping,
  hbeAddMapping,
} from "@/api/shoppingData";
import Loading from "@/components/Loading.vue";
import ConfirmBoxs from "@/components/confirmBoxs.vue";
import { formatDateTime } from "@/utils/utils.js";
export default {
  name: "HBEGroupMapping",
  components: {
    ConfirmBoxs,
    Loading,
  },
  data() {
    return {
      deletedialogVisible: false,
      deleteFlag: false,
      deleteparams: {},
      confirmFlag: false,
      changeRow: {},
      CountryCode: "",
      currentPage1: 1,
      form: {
        CName: "",
        EName: "",
        status: "true",
        score:"",
      },
      changeForm: {
        id: 0,
        CName: "",
        EName: "",
        Code: "",
        status: "false",
        score:"",
      },
      //新增dialog
      confirmIcon: "",
      confirmMsg: "",
      dialogFormVisible: false,
      changeCountryFlag: false,
      formLabelWidth: "150px",
      tableData: [],
      searchForm: {
        name: "",
        total: 0,
      },
      submitLoading: false,
      settingMappingFlag: false, //配置映射弹框
      settingRow: {},
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      sort: 0,//降序 0 升序1 默认降序
    };
  },
  mounted() {
    this.customSearch();
  },
  methods: {
    closeaddDialog(formRule) {
      console.log(formRule);
      this.$refs[formRule].resetFields();
    },
    //分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.customSearch(val);
      console.log(`当前页: ${val}`);
    },

    addGroup() {
      this.dialogFormVisible = true;
    },
    //新增保存
    async dataSave() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let saveParams = {
            CName: this.form.CName,
            EName: this.form.EName,
            status: this.form.status,
            score: this.form.score,
          };
          console.log(saveParams, "saveParams");
          hbeGroupSave(saveParams)
            .then((res) => {
              if (res.code == 200) {
                if (res.data.error.code == 2005) {
                  this.confirmFlag = true;
                  this.deleteFlag = false;
                  this.confirmMsg = res.data.error.message; //res.message
                  this.currentPage1 = 1;
                } else {
                  this.confirmFlag = true;
                  this.deleteFlag = false;
                  this.confirmMsg = "操作成功";
                  this.dialogFormVisible = false;
                  this.customSearch(this.currentPage1);
                  this.currentPage1 = 1;
                  //this.form = {};
                }
              } else {
                this.confirmFlag = true;
                this.deleteFlag = false;
                this.confirmMsg = res.message; //res.message
                this.currentPage1 = 1;
              }
            })
            .catch(function (error) {
              console.log("新增失败", error.objError);
              this.customSearch();
            });

          // this.form = {};
        }
      });
    },
    // 修改保存
     changeSave() {
      this.$refs["editForm"].validate((valid) => {
        if(valid){
          let saveParams = {
            id: this.changeRow.id,
            CName: this.changeForm.CName,
            EName: this.changeForm.EName,
            status: this.changeForm.status,
            score: this.changeForm.score,
          };
          hbeGroupSave(saveParams)
            .then((res) => {
              if (res.code == 200) {
                if (res.data.error.code == 2005) {
                  this.confirmFlag = true;
                  this.deleteFlag = false;
                  this.confirmMsg = res.data.error.message;
                } else {
                  this.confirmFlag = true;
                  this.deleteFlag = false;
                  this.confirmMsg = "修改成功";
                  this.currentPage1 = 1;
                  this.changeCountryFlag = false;
                  this.customSearch(this.currentPage1);
                }
              } else {
                this.confirmFlag = true;
                this.deleteFlag = false;
                this.confirmMsg = res.message;
              }
            })
            .catch(function (error) {
              console.log("修改失败", error.objError);
            });
        }
      });
    },
    //修改button
    handleChange(row) {
      this.changeRow = row;
      this.changeCountryFlag = true;
      this.changeForm.id = this.changeRow.id;
      this.changeForm.CName = this.changeRow.cName;
      this.changeForm.EName = this.changeRow.eName;
      this.changeForm.score = this.changeRow.score;
      this.changeForm.status = this.changeRow.status.toString();
    },
    //取消button
    cancel() {
      this.dialogFormVisible = false;
      this.changeCountryFlag = false;
      this.form.countryCode = "";
      this.form.nationEN = "";
      this.form.nationCH = "";
    },
    //删除dialog
    cancelDelete() {
      this.deletedialogVisible = false;
    },
    //删除
    deleteRow(row) {
      this.deletedialogVisible = true;
      this.deleteparams = {
        params: {
          id: row.id,
        },
      };
    },
    async confirmDelete() {
      this.deletedialogVisible = false;
      hbeGroupDelete(this.deleteparams)
        .then((res) => {
          if (res.code == 200) {
            this.confirmFlag = true;
            this.confirmMsg = "删除成功";
            this.currentPage1 = 1;
            this.customSearch(this.currentPage1);
          } else {
            this.confirmFlag = true;
            this.confirmMsg = "删除失败";
          }
        })
        .catch(() => {
          console.log("删除请求失败");
        });
    },
    //搜索button
    async customSearch(int) {
      this.currentPage1=int ? int : 1;
      this.submitLoading = true;
      let searchparams = {
        params: {
          name: this.searchForm.name,
          sort: this.sort,
          page: int ? int : 1,
          pageSize: 10,
        },
      };
      await hbeGroupList(searchparams)
        .then((res) => {
          console.log(res);
          this.submitLoading = false;
          this.tableData = res.data.list;
          this.searchForm.total = res.data.total;
        })
        .catch(function (error) {
          this.submitLoading = false;
          console.log("请求失败", error.objError);
        });
    },
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
    Format(value, index) {
      if (index.property == "createdDate") {
        return formatDateTime(value.createdDate,"YYYY-MM-DD HH:mm:ss");
      } else if (index.property == "status") {
        return value.status ? "启用" : "禁用";
      }
    },
    //配置button
    handleSetting(row) {
      this.settingRow = row;
      this.getMapping();
      this.settingMappingFlag = true;
    },
    //配置映射
    async getMapping() {
      this.dynamicTags=[];
      this.submitLoading = true;
      this.inputVisible = false;
      let searchparams = {
        params: {
          id: this.settingRow.id,
        },
      };
      await hbeGetMapping(searchparams)
        .then((res) => {
          this.submitLoading = false;
          this.dynamicTags = res.data;
        })
        .catch(function (error) {
          this.submitLoading = false;
          console.log("请求失败", error.objError);
        });
    },
    //删除
    async handleClose(tag) {
      // this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      this.submitLoading = true;
      let searchparams = {
        params: {
          id: tag.id,
        },
      };
      await hbeDeleteMapping(searchparams)
        .then((res) => {
          this.submitLoading = false;
          if (res.code == 200 && res.data > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.dynamicTags[i].id === tag.id) {
                this.dynamicTags.splice(i, 1);
              }
            }
          } else {
            this.confirmFlag = true;
            this.confirmMsg = "删除失败请重新删除";
          }
        })
        .catch(function (error) {
          this.submitLoading = false;
          console.log("请求失败", error.objError);
        });
    },
    //添加
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    //添加完成
    async handleInputConfirm() {
      this.submitLoading = true;
      let inputValue = this.inputValue;
      if (inputValue == "") {
        this.confirmFlag = true;
        this.confirmMsg = "请输入正确的酒店code";
        this.submitLoading = false;
        return;
      }
      let searchparams = {
        params: {
          cwtid: this.settingRow.id,
          code: inputValue,
        },
      };
      await hbeAddMapping(searchparams)
        .then((res) => {
          this.submitLoading = false;
          if (res.code == 200 && res.data > 0) {
            this.getMapping();
          } else {
            this.confirmFlag = true;
            this.confirmMsg = res.message;
          }
        })
        .catch(function (error) {
          this.submitLoading = false;
          this.confirmFlag = true;
          this.confirmMsg = "添加失败请重新添加";
          console.log("请求失败", error.objError);
        });

      this.inputVisible = false;
      this.inputValue = "";
    },
    sortChange(column){
      this.sort = column.order == "ascending" ? 1 : 0;
      this.customSearch();
    },
  },
};
</script>

<style scoped>
.paginationsty {
  float: right;
  margin: 1rem 0;
}

.pos_container_panel {
  padding: 0 16rem 4rem;
}

.harpIDbtn {
  width: 10rem;
  height: 3rem;
  padding: 0 !important;
  font-size: 1rem !important;
}
</style>
